import React from "react"
import { useSelector } from "react-redux"
import { formSubmissionClosed } from "reduxSlices/formSubmissionSlice"
import { resolutionSet, resolutionText } from "reduxSlices/formSubmissionResolutionSlice"
import ItemRow from "shared/ItemRow"
import ResolutionMenu from "./ResolutionMenu"

const Resolution = () => {
  const formSubmissionHasResolution = useSelector(resolutionSet)
  const formSubmissionIsClosed = useSelector(formSubmissionClosed)
  const text = useSelector(resolutionText)

  if (!formSubmissionHasResolution && formSubmissionIsClosed) {
    return (
      <p>
        No resolution was added before the submission was closed.
      </p>
    )
  }

  if (!formSubmissionHasResolution) return null

  const showMenu = !formSubmissionIsClosed

  return (
    <ItemRow
      itemRowHeaderContent={(
        <span>Resolution Text:</span>
      )}
      itemRowHeaderControls={(
        <>
          {
            showMenu && (
              <ResolutionMenu
                className="shrink-0"
              />
            )
          }
        </>
      )}
      itemRowBody={(
        <div className="whitespace-pre-wrap">{text}</div>
      )}
    />
  )
}

export default Resolution
